import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  UpdateFlexibleBenefitComponentMutationResponse,
  UpdateFlexibleBenefitComponentMutationVariables,
  UpdateFlexibleBenefitComponentInput,
} from '../types';

const updateFlexibleBenefitMutation = gql`
  mutation UpdateFlexibleBenefitsComponent($input: UpdateComponentRequestInput!) {
    payrollUpdateFlexibleBenefitsComponent(input: $input) {
      component {
        id
        name
        description
        category
        is_active
        settings {
          salary_settings {
            show_in_gross_salary
            non_cash_benefit
          }
          benefit_amount_settings {
            unit
            list_of_options_amount {
              amounts
              default_option_index
              allow_multiple
              amount_labels
            }
            fixed_amount {
              amount
              description
            }
          }
          tax_behaviour {
            tax_exempt_in_old_regime
            tax_exempt_in_new_regime
            tax_exemption_section
            tax_deduction_behaviour
          }
          display_behaviour {
            show_zero
            visible_to_employee
            display_name
          }
          declaration_settings {
            declaration_enabled
          }
          hold_settings {
            hold_unclaimed_amount
          }
          arrear_behaviour {
            consider_in_arrear
            allow_negative
          }
          proration_behaviour {
            support_proration
          }
          pf_behaviour {
            include_in_pf_wages
          }
          esi_behaviour {
            include_in_esi_wages
          }
          pt_behaviour {
            include_in_pt_wages
          }
          lwf_behaviour {
            include_in_lwf_wages
          }
          gratuity_behaviour {
            include_in_gratuity_wages
          }
          leave_encashment_behaviour {
            include_in_leave_encashment_wages
          }
          ot_behaviour {
            include_in_ot_wages
          }
          base_compensation_behaviour {
            include_in_base_compensation
          }
        }
        component_type
        component_space
        tenant_id
        created_at
        updated_at
      }
      code
      success
      message
    }
  }
`;

export const updateFlexibleBenefit = (input: UpdateFlexibleBenefitComponentInput) => {
  return graphQLApi<
    UpdateFlexibleBenefitComponentMutationResponse,
    UpdateFlexibleBenefitComponentMutationVariables
  >({
    query: updateFlexibleBenefitMutation,
    queryVariables: { input },
  });
};
